module.exports = __webpack_public_path__ + "3bba4f3bded944d8c3b90293a60551bd.svg";